var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-3 pt-5 mt-5"},[_c('center',[_c('hour-glass')],1)],1),_c('h4',{staticClass:"pb-5 mb-5"},[_c('center',[_vm._v(" Memuat.. ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }